<script setup lang="ts">
import { useAppStoreWithOut } from "@/store/modules/app"
import { computed } from "vue"
import sysIcons from "./utils.js"

const appStore = useAppStoreWithOut()

const props = defineProps({
  name: { type: String, required: true },
  color: { type: String, default: "currentColor" },
  size: { type: String, default: '100%' },
  invert: { type: Boolean, default: false },
  borderRadius: { type: String, default: '8px' },
})

const icon = computed(() => {

  // return appStore.getIcon[props.name] || null

  const sysIcon = sysIcons.find(item => item.name === props.name)
  
  if (!sysIcon) return null

  let parser = new DOMParser()
  let doc = parser.parseFromString(sysIcon.svg, "image/svg+xml")
  let svg = doc.documentElement

  // 移除写死的宽高
  svg.removeAttribute("width")
  svg.removeAttribute("height")

  return svg.outerHTML
})
const style = computed(() => {
  let res:any = {
    width: props.size + 'px',
    height: props.size + 'px',
    lineHeight: props.size + 'px',
    borderRadius: props.borderRadius,
  }
  if (props.invert) {
    res.backgroundColor = props.color
  }
  return res
})
</script>

<template>
  <div v-if="icon" :style="style">
    <svg
      class="svg-icon"
      aria-hidden="true"
      :style="{ color: invert?'#FFF':color, width: size, height: size }"
      v-html="icon" />
  </div>
</template>

<style scoped>
.svg-icon {
  display: inline-block;
  vertical-align: middle;
  fill: currentColor; /* 关键点：让颜色继承 color */
}
</style>
